﻿import { EmailFamily } from '../../enums/index';

export interface IEmailEntityContract {
    id: number;
    emailFamily: EmailFamily;
    emailType: number;
    excelId: number;
}
